import { createRouter, createWebHashHistory } from 'vue-router'
import Layout from '@/layout/index.vue'
import Cookies from 'js-cookie'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {
  BookOutlined,
  ExperimentOutlined,
  FolderOutlined,
  SafetyOutlined,
  UserOutlined,
  // TeamOutlined,
  HomeOutlined,
} from '@ant-design/icons-vue'

const routes = [
  {
    path: '/',
    redirect: '/login',
    meta: { requiresAuth: false }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录', hidden: true, requiresAuth: false }
  },
  // IEP 登录
  {
    path: '/IEPlogin',
    name: 'IEPlogin',
    component: () => import('@/views/login/IEPlogin.vue'),
    meta: { title: '登录', hidden: true, requiresAuth: false }
  },
  // 资源教室 登录
  {
    path: '/classlogin',
    name: 'Classlogin',
    component: () => import('@/views/login/Classlogin.vue'),
    meta: { title: '登录', hidden: true, requiresAuth: false }
  },
  // 送教上门
  {
    path: '/visitLogin',
    name: 'VisitLogin',
    component: () => import('@/views/login/visitLogin.vue'),
    meta: { title: '登录', hidden: true, requiresAuth: false }
  },
  // 培智课程
  {
    path: '/courseLogin',
    name: 'CourseLogin',
    component: () => import('@/views/login/courseLogin.vue'),
    meta: { title: '登录', hidden: true, requiresAuth: false }
  },
  // 肢体类
  {
    path: '/limbsLogin',
    name: 'LimbsLogin',
    component: () => import('@/views/login/limbsLogin.vue'),
    meta: { title: '登录', hidden: true, requiresAuth: false }
  },
  // 心理类
  {
    path: '/psycholLogin',
    name: 'psycholLogin',
    component: () => import('@/views/login/psycholLogin.vue'),
    meta: { title: '登录', hidden: true, requiresAuth: false }
  },
  // 言语和智力
  {
    path: '/speechLogin',
    name: 'speechLogin',
    component: () => import('@/views/login/speechLogin.vue'),
    meta: { title: '登录', hidden: true, requiresAuth: false }
  },
  // 孤独症
  {
    path: '/autismLogin',
    name: 'autismLogin',
    component: () => import('@/views/login/autismLogin.vue'),
    meta: { title: '登录', hidden: true, requiresAuth: false }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/statistics',
    children: [
      {
        path: 'index',
        name: 'index',
        component: () => import('@/views/index.vue'),
        meta: { title: '总览', icon: 'bar-chart' }
      },
      {
        path: 'swiper',
        name: 'swiper',
        component: () => import('@/views/Swiper.vue'),
        meta: { title: '轮播图', icon: 'bar-chart' }
      },
      {
        path: 'ai',
        name: 'ai',
        component: () => import('@/views/ai/index.vue'),
        meta: { title: 'AI智能', icon: 'bar-chart' }
      },
      {
        path: 'statistics',
        name: 'statistics',
        component: () => import('@/views/statistics/index.vue'),
        meta: { title: '数据统计', icon: 'bar-chart' }
      },
      {
        path: 'resources',
        name: 'resources',
        component: () => import('@/views/resources/onlineCourse.vue'),
        meta: { title: '本校资源', icon: 'database' }
      },
      {
        path: 'onlineCourse',
        name: 'onlineCourse',
        component: () => import('@/views/resources/onlineCourse.vue'),
        meta: { title: '云资源', icon: 'database' }
      },
      {
        path: 'schoolCourse',
        name: 'schoolCourse',
        component: () => import('@/views/resources/schoolCourse.vue'),
        meta: { title: '本校资源', icon: 'database' }
      },
      {
        path: 'entranceSchool',
        name: 'EntranceSchool',
        component: () => import('@/views/entranceSchool/index.vue'),
        meta: { title: '入学评估' }
      },
      // 评估
      {
        path: 'evaluation',
        children: [
          {
            path: '',
            name: 'Evaluation',
            component: () => import('@/views/evaluation/index.vue'),
            meta: { title: '评估', },
          },
          {
            path: 'ATECStudents',
            name: 'ATECStudents',
            component: () => import('@/views/evaluation/student.vue'),
            meta: { title: '孤独症治疗评估', }
          },
          {
            path: 'CPEP3Students',
            name: 'CPEP3Students',
            component: () => import('@/views/evaluation/students.vue'),
            meta: { title: '儿童发展能力观察量表(CDOS)', }
          },
          {
            path: 'ABCStudents',
            name: 'ABCStudents',
            component: () => import('@/views/evaluation/students.vue'),
            meta: { title: 'ABC评估', }
          },
          {
            path: 'parentStudents',
            name: 'parentStudents',
            component: () => import('@/views/evaluation/students.vue'),
            meta: { title: '父母评估', }
          },
          {
            path: 'teacherStudents',
            name: 'teacherStudents',
            component: () => import('@/views/evaluation/students.vue'),
            meta: { title: '教师评估', }
          },
          {
            path: 'CARSStudents',
            name: 'CARSStudents',
            component: () => import('@/views/evaluation/students.vue'),
            meta: { title: '自闭症CARS评估', }
          },
          {
            path: 'vbMapptudents',
            name: 'vbMappStudents',
            component: () => import('@/views/evaluation/students.vue'),
            meta: { title: '儿童发展评估与个别化安置系统(CDA-IPS)', }
          },
          {
            path: 'ChineseStudents',
            name: 'ChineseStudents',
            component: () => import('@/views/evaluation/students.vue'),
            meta: { title: '生活语文评估', }
          },
          {
            path: 'mathematicsStudents',
            name: 'mathematicsStudents',
            component: () => import('@/views/evaluation/students.vue'),
            meta: { title: '生活数学评估', }
          },
          {
            path: 'adaptStudents',
            name: 'adaptStudents',
            component: () => import('@/views/evaluation/students.vue'),
            meta: { title: '生活适应评估', }
          },
          {
            path: 'senseStudents',
            name: 'senseStudents',
            component: () => import('@/views/evaluation/students.vue'),
            meta: { title: '感官知觉评估', }
          },
          {
            path: 'perceiveStudents',
            name: 'perceiveStudents',
            component: () => import('@/views/evaluation/students.vue'),
            meta: { title: '认知能力评估', }
          },
          {
            path: 'languageStudents',
            name: 'languageStudents',
            component: () => import('@/views/evaluation/students.vue'),
            meta: { title: '语言沟通评估', }
          },
          {
            path: 'emotionStudents',
            name: 'emotionStudents',
            component: () => import('@/views/evaluation/students.vue'),
            meta: { title: '情绪行为评估', }
          },
          {
            path: 'lifeCareOnseseifStudents',
            name: 'lifeCareOnseseifStudents',
            component: () => import('@/views/evaluation/students.vue'),
            meta: { title: '生活自理评估', }
          },
          {
            path: 'societyStudents',
            name: 'societyStudents',
            component: () => import('@/views/evaluation/students.vue'),
            meta: { title: '社会交往评估', }
          },
          {
            path: 'CbclStudents',
            name: 'CbclStudents',
            component: () => import('@/views/evaluation/students.vue'),
            meta: { title: '儿童行为评估', }
          },
          {
            path: 'MHTStudents',
            name: 'MHTStudents',
            component: () => import('@/views/evaluation/students.vue'),
            meta: { title: '学生心理健康评估', }
          },
          {
            path: 'GMFMStudents',
            name: 'GMFMStudents',
            component: () => import('@/views/evaluation/students.vue'),
            meta: { title: '粗大运动评估', }
          },
          {
            path: 'FMFMStudents',
            name: 'FMFMStudents',
            component: () => import('@/views/evaluation/students.vue'),
            meta: { title: '精细运动评估', }
          },
          {
            path: 'ssStudents',
            name: 'ssStudents',
            component: () => import('@/views/evaluation/students.vue'),
            meta: { title: 'S-S发育迟缓评估', }
          },
          {
            path: 'wechslerIntelligenceStudents',
            name: 'wechslerIntelligenceStudents',
            component: () => import('@/views/evaluation/students.vue'),
            meta: { title: '韦氏智力评估', }
          },
          {
            path: 'sensoryIntegrationStudents',
            name: 'sensoryIntegrationStudents',
            component: () => import('@/views/evaluation/students.vue'),
            meta: { title: '感觉统合评估', }
          },
          {
            path: 'socialBehaviourStudents',
            name: 'socialBehaviourStudents',
            component: () => import('@/views/evaluation/students.vue'),
            meta: { title: '社交行为SRS评估', }
          },
          {
            path: 'rwjdzlStudents',
            name: 'rwjdzlStudents',
            component: () => import('@/views/evaluation/students.vue'),
            meta: { title: '瑞文经典之智力评估', }
          },
          {
            path: 'rxpgStudents',
            name: 'rxpgStudents',
            component: () => import('@/views/evaluation/students.vue'),
            meta: { title: '入学适应能力测评系统', }
          },
        ]
      },
      // 训练
      {
        path: 'training',
        children: [
          {
            path: '',
            name: 'Training',
            component: () => import('@/views/training/index.vue'),
            meta: { title: '训练', icon: ExperimentOutlined }
          },
          {
            path: 'gdz',
            name: 'Gdz',
            component: () => import('@/views/training/classify.vue'),
            meta: { title: '孤独症训练', },
          },
          {
            path: 'course',
            name: 'Course',
            component: () => import('@/views/training/classify.vue'),
            meta: { title: '培智课程训练', },
          },
          {
            path: 'sjsm',
            name: 'Sjsm',
            component: () => import('@/views/training/classify.vue'),
            meta: { title: '送教上门训练', },
          },
          {
            path: 'xll',
            name: 'Xll',
            component: () => import('@/views/training/classify.vue'),
            meta: { title: '心理类训练', },
          },
          {
            path: 'ztl',
            name: 'Ztl',
            component: () => import('@/views/training/classify.vue'),
            meta: { title: '肢体类训练', },
          },
          {
            path: 'speak',
            name: 'Speak',
            component: () => import('@/views/training/classify.vue'),
            meta: { title: '言语和智力类训练', },
          },
          {
            path: 'zyjs',
            name: 'Zyjs',
            component: () => import('@/views/training/classify.vue'),
            meta: { title: '资源教室训练', },
          },
        ]
      },
      // {
      //   path: 'trainingStudent',
      //   name: 'TrainingStudent',
      //   component: () => import('@/views/training/student.vue'),
      //   meta: { title: '训练学生', icon: ExperimentOutlined }
      // },
      // {
      //   path: 'trainingRecord',
      //   name: 'TrainingRecord',
      //   component: () => import('@/views/training/gdzRecord.vue'),
      //   meta: { title: '训练记录', icon: ExperimentOutlined }
      // },
      {
        path: 'teacher',
        name: 'teacher',
        component: () => import('@/views/basic/teacher/index.vue'),
        meta: { title: '教师管理', icon: HomeOutlined }
      },
      {
        path: 'class',
        children: [
          {
            path: '',
            name: 'Class',
            component: () => import('@/views/basic/class/index.vue'),
            meta: { title: '班级管理', },
          },
          {
            path: '/class/evaluate',
            name: 'ClassEvaluate',
            component: () => import('@/views/basic/class/classEvaluate.vue'),
            meta: { title: '班级评估数据', },
          },
        ]
      },
      {
        path: 'student',
        children: [
          {
            path: '',
            name: 'Student',
            component: () => import('@/views/basic/student/index.vue'),
            meta: { title: '学生管理', icon: UserOutlined },
          },
          {
            path: '/student/evaluate',
            name: 'StudentEvaluate',
            component: () => import('@/views/basic/student/studentEvaluate.vue'),
            meta: { title: '学生评估数据', },
          },
        ]
      },
      {
        path: 'plan',
        name: 'plan',
        component: () => import('@/views/plan/index.vue'),
        meta: { title: 'IEP计划', icon: FolderOutlined }
      },
      {
        path: 'homeschool',
        name: 'homeschool',
        component: () => import('@/views/homeSchool/index.vue'),
        meta: { title: '家校共育', icon: FolderOutlined }
      },
      // 其他

      {
        path: 'teachGl/schoolCourse',
        name: 'schoolCourse',
        component: () => import('@/views/resources/schoolCourse.vue'),
        meta: { title: '本校资源', },
      },
      {
        path: 'other/teachGL',
        name: 'teachGL',
        component: () => import('@/views/other/teachGL.vue'),
        meta: { title: '教研管理', },
      },
      {
        path: 'other/specialDT',
        name: 'specialDT',
        component: () => import('@/views/other/specialDT.vue'),
        meta: { title: '特教动态', },
      },
      {
        path: 'other/consultGL',
        name: 'consultGL',
        component: () => import('@/views/other/consultGL.vue'),
        meta: { title: '咨询管理', },
      },
      {
        path: 'other/cultivateXT',
        name: 'cultivateXT',
        component: () => import('@/views/other/cultivateXT.vue'),
        meta: { title: '培训系统', },
      },
      {
        path: 'other/zddp',
        name: 'zddp',
        component: () => import('@/views/other/zddp.vue'),
        meta: { title: '指导督评', },
      },
      {
        path: 'other/fileAcceptAndSend',
        name: 'fileAcceptAndSend',
        component: () => import('@/views/other/fileAcceptAndSend.vue'),
        meta: { title: '文件收发', },
      },
      {
        path: 'other/dataReport',
        name: 'dataReport',
        component: () => import('@/views/other/dataReport.vue'),
        meta: { title: '数据上报', },
      },
      {
        path: 'other/resourceRoom',
        name: 'resourceRoom',
        component: () => import('@/views/other/resourceRoom.vue'),
        meta: { title: '资源教室', },
      },




      {
        path: 'teachGl/schoolCourse',
        name: 'schoolCourse',
        component: () => import('@/views/resources/schoolCourse.vue'),
        meta: { title: '本校资源', },
      },
      {
        path: 'teachGl/listenCourse',
        name: 'listenCourse',
        component: () => import('@/views/teachGl/listenCourse.vue'),
        meta: { title: '听评课', },
      },
      {
        path: 'teachGl/textbook',
        name: 'textbook',
        component: () => import('@/views/teachGl/textbook.vue'),
        meta: { title: '培智教材', },
      },
      {
        path: 'teachGl/teacherTrain',
        name: 'teacherTrain',
        component: () => import('@/views/teachGl/teacherTrain.vue'),
        meta: { title: '教师培训', },
      },
      {
        path: 'teachGl/aloneCouorse',
        name: 'aloneCouorse',
        component: () => import('@/views/teachGl/aloneCouorse.vue'),
        meta: { title: '自主备课', },
      },
      {
        path: 'teachGl/collectiveCourse',
        name: 'collectiveCourse',
        component: () => import('@/views/teachGl/collectiveCourse.vue'),
        meta: { title: '集体备课', },
      },






      {
        path: 'consultancy/specialState',
        name: 'specialState',
        component: () => import('@/views/consultancy/specialState.vue'),
        meta: { title: '特教动态', },
      },
      {
        path: 'consultancy/school',
        name: 'school',
        component: () => import('@/views/consultancy/school.vue'),
        meta: { title: '校园风采', },
      },







      {
        path: 'course',
        name: 'course',
        component: () => import('@/views/course/index.vue'),
        meta: { title: '在线课程', icon: FolderOutlined }
      },
      {
        path: 'video',
        name: 'video',
        component: () => import('@/views/course/video.vue'),
        meta: { title: '查看视频', icon: FolderOutlined, hidden: true }
      },
      {
        path: 'rights',
        name: 'Rights',
        component: () => import('@/views/rights/index.vue'),
        meta: { title: '权限管理', icon: SafetyOutlined }
      },
      {
        path: 'user',
        name: 'SystemUser',
        component: () => import('@/views/system/user/index.vue'),
        meta: { title: '管理员管理' }
      },
      {
        path: 'role',
        name: 'SystemRole',
        component: () => import('@/views/system/role/index.vue'),
        meta: { title: '角色管理' }
      },
      {
        path: 'menu',
        name: 'SystemMenu',
        component: () => import('@/views/system/menu/index.vue'),
        meta: { title: '菜单管理' }
      },
      {
        path: 'log',
        name: 'SystemLog',
        component: () => import('@/views/system/log/index.vue'),
        meta: { title: '系统日志' }
      },
      {
        path: 'monitor',
        name: 'Monitor',
        component: () => import('@/views/system/monitor/index.vue'),
        meta: { title: '账号监听' }
      },
      {
        path: 'task',
        name: 'SystemTask',
        component: () => import('@/views/system/task/index.vue'),
        meta: { title: '定时任务' }
      },
      {
        path: 'param',
        name: 'SystemParam',
        component: () => import('@/views/system/param/index.vue'),
        meta: { title: '参数管理' }
      },
      {
        path: 'eAndtJurisdiction',
        name: 'eAndtJurisdiction',
        component: () => import('@/views/system/eAndtJurisdiction.vue'),
        meta: { title: '权限管理' }
      },
    ]
  },
  {
    path: '/plan/evaluate',
    name: 'planEvaluate',
    component: () => import('@/views/plan/evaluate.vue'),
    meta: { title: '开始评估', },
  },
  {
    path: '/plan/report',
    name: 'planReport',
    component: () => import('@/views/plan/report.vue'),
    meta: { title: 'IEP报告', icon: FolderOutlined }
  },
  {
    path: '/plan/analyse',
    name: 'planAnalyse',
    component: () => import('@/views/plan/analyse.vue'),
    meta: { title: 'VB-MAPP对比分析', icon: FolderOutlined }
  },
  {
    path: '/evaluation/test',
    name: 'EvaluationTest',
    component: () => import('@/views/evaluation/test.vue'),
    meta: { title: '评估测评', icon: BookOutlined }
  },
  {
    path: '/evaluation/type',
    name: 'EvaluationBulky',
    component: () => import('@/views/evaluation/type/index.vue'),
    meta: { title: '评估测评', icon: BookOutlined }
  },
  {
    path: '/evaluation/type/affairConcept',
    name: 'affairConcept',
    component: () => import('@/views/evaluation/type/ssEvaluation/affairConcept.vue'),
    meta: { title: '事务概念评估', }
  },
  {
    path: '/evaluation/report',
    name: 'EvaluationReport',
    component: () => import('@/views/evaluation/report.vue'),
    meta: { title: '评估报告', icon: BookOutlined }
  },

  {
    path: '/evaluation/report/test',
    name: 'EvaluationReportTest',
    component: () => import('@/views/evaluation/report/index.vue'),
    meta: { title: '评估报告', icon: BookOutlined }
  },
  {
    path: '/evaluation/score/test',
    name: 'exquisiteScore',
    component: () => import('@/views/evaluation/score/index.vue'),
    meta: { title: '得分详情', icon: BookOutlined }
  },
  {
    path: '/evaluation/contrastiveAnalyst/test',
    name: 'exquisiteAnalyst',
    component: () => import('@/views/evaluation/contrastiveAnalyst/index.vue'),
    meta: { title: '对比报告', icon: BookOutlined }
  },
  // ---------------------------

  {
    path: '/evaluation/anaysis',
    name: 'EvaluationDetailComparativeAnalysis',
    component: () => import('@/views/evaluation/comparativeAnalysis.vue'),
    meta: { title: '评估对比分析', icon: BookOutlined }
  },

  // {
  //   path: '/training/gdzTest',
  //   name: 'TrainingGdzTest',
  //   component: () => import('@/views/training/gdzTest.vue'),
  //   meta: { title: '训练练习', icon: BookOutlined }
  // },
  // {
  //   path: '/training/ATECIndex',
  //   name: 'TrainingATECIndex',
  //   component: () => import('@/views/training/gdzIndex.vue'),
  //   meta: { title: '孤独症治疗ATEC练习首页', icon: BookOutlined }
  // },
  {
    path: '/training/trainingIndex',
    name: 'trainingIndex',
    component: () => import('@/views/training/type/trainingIndex.vue'),
    meta: { title: '练习首页', icon: BookOutlined }
  },
  // {
  //   path: '/training/CPEP3Index',
  //   name: 'CPEP3Index',
  //   component: () => import('@/views/training/CPEP3/index.vue'),
  //   meta: { title: 'CPEP3训练', icon: BookOutlined }
  // },
  // {
  //   path: '/training/socialContact',
  //   name: 'socialContact',
  //   component: () => import('@/views/training/socialContact/socialIndex.vue'),
  //   meta: { title: '社交行为训练', icon: ExperimentOutlined }
  // },
  {
    path: '/lock',
    name: 'Lock',
    component: () => import('@/views/lock/index.vue'),
    meta: { title: '锁屏', hidden: true }
  },
  // {
  //   path: '/test',
  //   name: 'Test',
  //   component: () => import('@/views/test/index.vue'),
  //   meta: { title: '测试题', hidden: true }
  // },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/views/error/404.vue'),
    meta: { title: '404' }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404',
    meta: { hidden: true }
  }
]

const router = createRouter({
  history: createWebHashHistory(),  // 使用 hash 模式
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  },
  routes
})

router.beforeEach((to, from, next) => {
  NProgress.start()

  const token = localStorage.getItem('token') || Cookies.get('token')
  const title = localStorage.getItem('title')

  let titleList = ['特殊儿童IEP智能决策系统', '资源教室智能体评估平台', '孤独症谱系智能干预评估训练系统', '特殊儿童课程专项评估训练系统', '特殊儿童送教上门多维评估与专项训练系统', '特殊儿童心理发展评估与神经适应系统', '特殊儿童神经肌肉评估训练系统', '特殊儿童语言脑功能与整合干预系统']

  // let pathList = [
  //   '/speechLogin',
  //   '/IEPlogin',
  //   '/classlogin',
  //   '/visitLogin',
  //   '/courseLogin',
  //   '/limbsLogin',
  //   '/psycholLogin',
  //   '/autismLogin',
  // ]


  // 设置页面标题（提前到最开始）
  document.title = titleList.includes(title) == true ? `${to.meta.title} - ${title}` : '特教综合康复管理云平台'
  // document.title = to.meta.title ? `${to.meta.title} - ${title}` : '特教综合康复管理云平台'
  // document.title = to.meta.title ? `${to.meta.title} - 特教Ai康复云平台` : '特教Ai康复云平台'

  // 不需要登录的页面直接放行
  if (to.meta.requiresAuth === false) {
    next()
    return
  }

  // 有 token 的情况
  if (token) {
    if (to.path === '/login') {
      NProgress.done() // 手动关闭，因为重定向会触发新的 beforeEach
      next('/')
    } else {
      next()
    }
  } else {
    // 没有 token 的情况
    if (to.path === '/login') {
      next()
    } else {
      NProgress.done() // 手动关闭，因为重定向会触发新的 beforeEach
      next(`/login?redirect=${to.path}`)
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})

export default router